import React from 'react';
import { LoaderTemplate } from 'themes/components';

function Loader() {
	return <LoaderTemplate />;
}

export default Loader;
